const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速秒开引擎',
    desc: '采用智能多线加速技术，点开视频即可播放，无需等待缓冲。无论热门大片还是冷门老片，都能享受流畅观影体验。',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-4k-line',
    title: '超清画质呈现',
    desc: '支持1080P全高清至4K超清画质，根据您的网络环境智能适配最佳分辨率。每一帧画面都细腻清晰，还原影院级视觉享受。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全终端畅快看',
    desc: '电脑、平板、手机全终端自适应，界面简洁易操作。支持倍速播放、记忆续播、收藏追剧等贴心功能，随时随地想看就看。',
    color: 'bg-secondary-100 text-secondary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            三大核心技术，打造极致的免费高清观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <article key={feature.title} className="rounded-2xl bg-background-50 p-7 md:p-8">
              <span className={`w-12 h-12 flex items-center justify-center rounded-xl ${feature.color} mb-5`}>
                <i className={`${feature.icon} text-2xl`}></i>
              </span>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}